module.exports = __webpack_public_path__ + "static/media/cobertura.565b6e8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/tiendamia/cobertura.png
// module id = 1193
// module chunks = 0